module.exports = __webpack_public_path__ + "img/unionpay.a6565216.svg";